import { useState } from 'react';
import { Check } from 'phosphor-react';
import { hap } from '@/lib/haptics';
import { formatDayShort } from '@/lib/dates';

export function TamponJyEtais({ at, onToggle }: { at?: string | null; onToggle?: (on: boolean) => void }) {
  const [stamped, setStamped] = useState(Boolean(at));
  const date = at ? formatDayShort(at).toUpperCase() : formatDayShort(new Date().toISOString()).toUpperCase();
  function click() {
    const next = !stamped;
    setStamped(next);
    if (next) hap.success(); else hap.light();
    onToggle?.(next);
  }
  if (stamped) {
    return (
      <button onClick={click} className="relative inline-block animate-tampon">
        <span className="block border-[2.5px] border-cerise rounded-md px-3 py-1.5 -rotate-[8deg] text-cerise font-serif italic text-[14px]">
          j’y étais · {date}
          <Check size={14} weight="bold" className="inline-block ml-1.5 -mt-0.5" />
        </span>
      </button>
    );
  }
  return (
    <button onClick={click} className="text-[13px] font-serif italic text-ink-2 hover:text-cerise transition">
      Marquer « j’y étais »
    </button>
  );
}
